import {
  STORAGE_FAILURE,
  STORAGE_REQUEST,
  STORAGE_RESET,
  STORAGE_SUCCESS,
} from "../actions/storage";

const initialState = {
  state: "idle",
};
export default function storage(state = initialState, action) {
  switch (action.type) {
    case STORAGE_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case STORAGE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    case STORAGE_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case STORAGE_RESET:
      return {
        ...state,
        ...action.payload,
        state: "reset",
      };
    default:
      return state;
  }
}
